import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  panel: {
    padding: '16px',
    width: '340px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  sectionLabel: {
    display: 'block',
    fontWeight: 'bold'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  inputLabel: {
    color: 'text.secondary'
  },
  helperText: {
    color: 'text.secondary'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '4px',
    flexShrink: 0
  }
});
